import { Spinner } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { BreedApi } from "../../../api";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { DrupalBreedInfoBox } from "../../common/DrupalBreedInfoBox";
import { DrupalFieldSet } from "../../common/DurpalFieldSet";
import { DrupalBreedSearchBar } from "./DrupalBreedSearchBar";

export interface IDrupalBreedPageProps {}

const BelgianBreedContainer = styled.div`
  background-color: #ffffff;
  border-radius: 3px;
  margin: 2rem;
`;

export const DrupalBreedPage: React.FunctionComponent<IDrupalBreedPageProps> = () => {
  const { t } = useTl();
  const breedApi = useApiService(BreedApi);

  const [data, loading] = useApiEffect(() => breedApi.getBelgianBreeds());

  return loading ? (
    <Spinner />
  ) : (
    <>
      <DrupalBreedSearchBar />
      <BelgianBreedContainer>
        <DrupalFieldSet title={t(ETLCodes.BelgianBreeds)} />
        <p>{t(ETLCodes.BelgianBreedParagraph)}</p>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {data.map((item, key) => (
            <DrupalBreedInfoBox
              key={key}
              breedName={item.officialName}
              breedId={item.breedId}
              imageLink={""}
            />
          ))}
        </div>
      </BelgianBreedContainer>
    </>
  );
};
